import { State } from 'reducers';
import { initialState } from 'reducers/deviceGroupReducer';
import { createSelector } from 'reselect';

const getSlice = (state: State) => state && state.deviceGroup || initialState;

export const getDeviceGroups =
    createSelector(
        getSlice,
        deviceGroup => deviceGroup.data
    );

export const isLoadingDeviceGroups =
    createSelector(
        getSlice,
        deviceGroup => deviceGroup.loading
    );

export const getDeviceGroupsError =
    createSelector(
        getSlice,
        deviceGroup => deviceGroup.error
    );



// WEBPACK FOOTER //
// ./src/selectors/deviceGroupSelectors.ts